export const freTexts = {
	knowMore: 'Savoir plus',
	ngoPurpose:
		"To raise funds for the NGO's projects, keep you up	to date on the NGO and the progress of the project you donated to and issue tax	deduction certificates.",
	termsPurpose:
		'Manage the business relationship in all its fields, as well as its donation and certificate application, and the sending of commercial communications electronically.',
	termsRights:
		'You have	the right to access, correct and delete your data, as well as other rights, as explained	in the additional information.',
	termsAdditionalInfo:
		'You can consult additional and detailed Data Protection information on our <a href="https://www.worldcoo.com/gdpr">website</a> or by <a href="mailto:rgpd@worldcoo.com">rgpd@worldcoo.com</a>',
	unexpectedError: "Une erreur inattendue s'est produite",
	amountError: `Le montant d'argent n'était pas valide`,
	authError: 'Une erreur s`est produite lors de l`autorisation du paiement',
	cardError: `Une erreur s'est produite avec votre carte`,
	referralError: 'Il y a eu une erreur de parrainage',
	transactionError: 'Il y a eu une erreur avec la transaction',
	resetFilters: 'Réinitialiser les filtres',
	basicNeeds: 'Besoins de base',
	category: 'Causer',
	humanRights: "Droits de l'homme",
	education: 'Éducation',
	emergency: 'Urgence',
	feeding: 'Alimentation',
	environment: 'Environnement',
	habitat: 'Habitat',
	health: 'Santé',
	clear: 'Effacer',
	active: 'Actif',
	finished: 'Terminé',
	status: 'État',
	filters: 'Filtres',
	year: 'An',
	treesFAQ1: 'Pouvez-vous nous en dire plus sur Conservation International ("CI") et son objectif ?',
	treesFAQ2: "En quoi consiste l'opération dédier un arbre ?",
	treesFAQ3:
		"Des frais seront-ils prélevés sur mon don ? Conservation International recevra-t-elle l'intégralité de mon don ?",
	treesFAQ4: `Qu'est-ce que Worldcoo ? Pourquoi mon don est-il transmi à Worldcoo et pas  directement à Conservation International ?`,
	treesFAQ5: `Comment la donation va apparaître sur mon relevé bancaire ?`,
	treesFAQ6: `Comment fonctionne le programme de dons équivalents?`,
	treesFAQResponse1: `CI est une organisation environnementale à but non lucratif, qui a été reconnue comme une organisation caritative au sens de l'article 501 (c) (3) aux États-Unis. Notez que CI n'est pas un organisme caritatif enregistré en France. Les principales priorités de CI sont: (i) la protection de la nature afin de mettre un terme au changement climatique; (ii) protéger l'océan afin de protéger l'humanité; et (iii) gestion durable des terres et des eaux. Depuis leur création, ils ont contribué à protéger plus de 6 millions de kilomètres carrés (2,3 millions de kilomètres carrés) de terres et de mers dans plus de 70 pays. Avec actuellement des bureaux dans 29 pays et 2 000 partenaires dans le monde, leur portée est véritablement mondiale. Veuillez consulter leur site internet pour plus de détails: https://www.conservation.org/about `,
	treesFAQResponse2: `Vous pouvez dédier votre don à un ami ou à un membre de votre famille («Bénéficiaire»). Si vous choisissez cette option, Mastercard Donate enverra un e-mail au destinataire en votre nom à l'adresse e-mail que vous indiquez pour le destinataire. Si vous ne souhaitez pas utiliser l'option Dédicace, vous pouvez simplement sauter cette étape et procéder à votre don. `,
	treesFAQResponse3: `Vous ne serez pas facturé de frais supplémentaires, cependant, sur le montant de votre don, des déductions seront effectuées pour les frais de traitement de carte standard et Worldcoo SL («Worldcoo»), un intermédiaire de collecte de fonds, facturera à Conservation International des frais administratifs de 6% sur votre don et récupérera tous les frais de traitement de transaction standard applicables encourus par eux. Lorsque vous allouez le paiement de votre don à Conservation International, Worldcoo le convertira d'EUR en USD en utilisant le taux de change en vigueur.`,
	treesFAQResponse4: `Worldcoo est une société de droit espagnol spécialisée dans le financement de projets sociaux et coopératifs par les sites de commerce électronique. Mastercard travaille avec Worldcoo pour faciliter les dons à Conservation International. Worldcoo effectuera un paiement correspondant du montant que vous avez donné à Conservation International en dollars américains. Les dons ne sont pas remboursables. Worldcoo apparaîtra comme le marchand officiel pour ce qui concerne le montant du don débité sur votre carte. Conservation International recevra les fonds dans les trois mois suivant votre don initial. Dans le cas exceptionnel où l’Association caritative ne serait pas en mesure d’accepter les fonds collectés via la plateforme Mastercard Donate (par exemple, si l’Association cesse d’exister ou perd son statut d’association caritative, etc.), votre don vous sera remboursé sans délai par Worldcoo. `,
	treesFAQResponse5: `Worldcoo apparaîtra comme le beneficiaire officiel sur votre relevé (pour le montant débité sur votre carte) pour ce qui concerne le don effecuté à Conservation International.`,
	treesFAQResponse6: `N'oubliez pas que les dons effectués avec votre carte Mastercard peuvent avoir un impact encore plus grand. Mastercard alloue les dons effectués en France à Conservation International en utilisant une carte Mastercard sur la page de don ci-dessus, jusqu'au 15 Mai 2021, arbre pour arbre, euro pour euro, jusqu'à un total de Euros 20,000. Voir la page de don pour les conditions supplémentaires. Merci de nous aider à démarrer un projet qui n'a pas de prix`,

	treesDonateInputMessage:
		"Utilisez votre carte Mastercard pour faire un don. Chaque somme récoltée donne lieu au versement d'une somme identique par Mastercard.**",
	aboutConservationInternational: 'A propos de Conservation International',
	dedicateToTemplate:
		'Hello! You receive this email because {{donorName}} has given you a donation of {{amount}} {{currency}} for the NGO {{ngoName}} in the campaign {{campaignName}}. This donation has been dedicated to you with the intention of making the world a little better place',

	dedicateToTemplateTitle: 'Votre message',
	dedicateToWarning:
		"Ce message sera envoyé au destinataire à l'adresse e-mail fournie ci-dessus. Je confirme avoir demandé l'autorisation du destinataire pour envoyer ce message.",
	dedicateToRecipientEmail: 'Email du destinataire.',
	dedicateToRecipientName: 'Nom du destinataire.',
	dedicateDonationTitle: "Je voudrais dédier ce don à quelqu'un",
	dedicateDonationMessage: "Je souhaite dédier mon don à quelqu'un",
	responsable: 'Controller',
	purpose: 'Objectif',
	legitimation: 'Authentification',
	recipients: 'Destinataires',
	rights: 'Droits',
	ngoAdditionalInfoTitle: 'Localisation et informations supplémentaires',
	termsButton: "Je lis, j'accepte et je comprends",
	id: "Carte d'identité",
	taxId: 'SIRET / TVA',
	passport: 'Passeport',
	others: 'Autres',
	termsAndCons: 'termes de protection des données Worldcoo',
	ngoTerms: 'Conditions de protection des données de',
	haveReadAndAccept: 'Je les ai lus, compris et acceptés',
	campaignAudited: 'Campagne auditée par',
	aCampaignBy: 'Une campagne de',
	acceptNgoTermsLink: 'termes de Protection des Données de {{ngo}}',
	acceptRecurrentTermsLink:
		'J\'ai lu, compris et accepté les <a class="terms_button" data-open-modal="recurrentTerms" data-modal-classes="terms-modal full-scroll" href="#">termes de Protection des Données des ONG</a>',
	activities: 'Activités',
	additionalInfo: 'Informations complémentaires',
	anyComments: 'Voulez-vous faire un commentaire?',
	businessName: 'Raison sociale',
	campaignObjectives: 'Objectifs du projet',
	campaignFunded: 'Campagne financée ',
	campaigns: 'Campagnes',
	cancel: 'Annuler',
	cardBrandNotAccepted: "Ce type de carte n'est pas accepté.",
	cardRegisteredSuccessfully: 'La carte a été enregistrée avec succès',
	cardsSupported: 'Cartes supportées:',
	certificateOnlyValidInExpeditionCountry:
		"Serà seulement possible d’avoir le reçu fiscal si le pays d'origine du don est le même où la association est enregistré.",
	certificateNeededData: 'Données nécessaires pour obtenir le certificat de donation:',
	change: 'Changer',
	checkoutSuccess: 'Votre don a été correctement effectué, merci pour votre collaboration!',
	city: 'Ville',
	collectedFundsDistribution: 'Les fonds collectés seront partagés à parts égales entre les projets suivants:',
	comments: 'Commentaires',
	company: 'Entreprise',
	confirm: 'Confirmer',
	contactData: 'Merci de renseigner le formulaire',
	cookiesMessage:
		'Ce site utilise des cookies. Si vous continuez à naviguer, nous considérons que vous acceptez son utilisation.',
	country: 'Pays',
	creditCard: 'Carte bancaire',
	dataReceivedSuccessfully: 'Nous avons correctement reçu vos données.',
	description: 'Description',
	directBeneficiaries: 'Bénéficiaires Directs',
	directBeneficiariesDescription: 'Les personnes qui ont bénéficié directement des actions du projet.',
	documentNumber: 'Numéro de document ',
	documentType: 'Document',
	donationAmount: 'Montant du don',
	donationAmountError: "Le montant du don n'est pas correct",
	donationAmountMinimumIs: 'Le montant minimum est de {{amount}}',
	donationCertificate: 'Certificat de donation',
	donations: 'Dons',
	donors: 'Donateurs',
	donated: 'Donnés',
	donatedOf: 'Collectés sur',
	donateMonthly: 'Faire un don mensuel',
	donationOnBehalf: 'Fer un don au nom de',
	door: 'Porte',
	email: 'Adresse e-mail ',
	fillFollowingFields: 'Vous devez compléter le formulaire',
	finish: 'Terminer',
	floor: 'Étage',
	funded: 'Financé',
	frenchFunded: 'Financés',
	genericCardError: 'Il y a eu une erreur avec votre carte.',
	goBack: 'Retour',
	identityDocument: "Carte d'identité",
	indicateDataToIdentify: 'Dites-nous cette information afin que nous puissions vous identifier:',
	indirectBeneficiaries: 'Bénéficiaires indirects',
	indirectBeneficiariesDescription:
		'Les personnes identifiables qui ont bénéficié indirectement des actions menées dans le cadre du projet.',
	inDoubtContactHere: 'Si vous avez des questions, vous pouvez nous contacter ici:',
	informYouViaMail: 'Nous vous informerons en détail par email.',
	makeDonation: 'Faire un don',
	makeOneTimeDonation: 'Faire un don unique',
	makeYourDonation: 'Faire un don',
	manageMyDonations: 'Gérer mes dons',
	manyThanks: 'Merci beaucoup!',
	modifyAmount: 'Modifier le montant du don',
	modifyRecurrentDonationSuccess:
		'<p class="margin-top-40">Nous avons bien reçu votre demande.</p><p>Dans quelques jours, nous vous enverrons un courrier électronique confirmant que les modifications que vous avez apportées ont été apportées.</p><p>Si vous avez des questions, vous pouvez nous contacter ici:</p><p class="margin-top-20"><strong><a href="mailto:contact@worldcoo.com">contact@worldcoo.com</a></strong></p>',
	modifyRecurrentDonationTitle: 'Si vous êtes déjà donateur, vous pouvez modifier ou annuler votre don ici:',
	moreInfo: "Plus d'information",
	name: 'Prénom',
	next: 'Suivant',
	otherAmount: 'Un autre montant',
	overlayError:
		"<p>Une erreur s'est produite</p><p>Réessayez ultérieurement ou contactez-nous ici:</p><p><strong>contact@worldcoo.com</strong></p>",
	particular: 'Particulier',
	paymentData: 'Information de paiement',
	paymentType: 'Moyen de paiement',
	personalData: 'Informations personnelles',
	pleaseFillFields: 'Veuillez renseigner les informations suivantes:',
	postalCode: 'Code postal',
	province: 'Commune',
	raised: 'Collectés',
	raisedTillNow: "Collectés jusqu'à maintenant:",
	region: 'Région',
	recurrentFormError:
		"Une erreur s'est produite lors du traitement de votre demande. Veuillez réessayer plus tard ou contactez-nous ici:",
	repeatEmail: 'Confirmez votre adresse e-mail',
	repsolEmployeesPortal: 'Portail de solidarité des employés',
	seeCampaigns: 'Voir des campagnes',
	send: 'Envoyer',
	share: 'Partagez',
	sorry: 'Nous sommes désolés!',
	stairNumber: 'Escalier',
	step1: 'Pas 1',
	step2: 'Pas 2',
	step3: 'Pas 3',
	step4: 'Pas 4',
	stopMakingDonation: 'Arrêtez de faire un don mensuel',
	streetName: 'Rue',
	streetNumber: 'Num.',
	streetType: 'Voie',
	summary: 'Résumé',
	surname: 'Nom',
	telefonicaUseCorporateMail:
		"* Si vous êtes un employé de Telefónica preferiblemente utilisez votre e-mail d'entreprise.",
	thanks: 'Merci beaucoup!',
	typeTheAmount: 'Tapez le montant',
	unavailableLanguageMessage:
		"Nous n'avons pas le contenu de cette campagne en français. Nous travaillons constamment pour fournir plus de contenu dans votre langue. Merci pour votre patience.",
	updatesAndLinks: 'Mises à jour et liens',
	validationEqualFields: 'Les adresses e-mail ne sont pas identiques',
	validationIsRequired: 'Ce champ est obligatoire',
	validationValidEmail: 'Ce champ doit contenir une adresse e-mail valide.',
	viewCampaignInfo: 'En savoir plus sur la campagne',
	viewInfo: 'En savoir plus ',
	wantCertificate: 'Je veux un reçu de réduction fiscale',
	wantWorldcooNewsletter: ' Je souhaite recevoir des informations de la part de Worldcoo',
	whatIsNewAmount: 'Dites-nous quel est le nouveau montant que vous souhaitez donner (en {{currency}}):',
	whatYouWantToDo: 'Que veux-tu faire?',
	whoWillBenefit: 'Qui en bénéficiera ?',
	youCanAlsoDonateOneTime: 'Vous pouvez également faire un don en temps opportun en accédant à l’un d’eux.',
	yourDonationWillBeCharged: 'Votre don sera facturé le 15 de chaque mois.',
	yourRequestIsProcessing: "Votre demande est en cours de traitement. Attends quelques secondes, s'il te plaît.",
	youSureCancelRecurrentDonation: 'Êtes-vous sûr de vouloir arrêter de faire un don mensuel?',
	ngoTermsTitle: 'Informations de base sur la protection des données',
	ngoLegitimation: 'The legal basis for handling your data is your consent.',
	ngoRecipients: 'No data shall be transferred to third parties.',
	ngoRights:
		"Vous disposez d'un droit d'accès, de rectification et de suppression des données, ainsi que d'autres droits, comme expliqué dans les informations complémentaires.",
	ngoAdditionalInfoEmail:
		'You can consult the additional and detailed information on Data Protection on the website of each NGO.',
	ngoAdditionalInfoUrl:
		'Vous pouvez consulter des informations supplémentaires et détaillées sur la protection des données sur notre site Web: ',
	amountMustBeGreaterThanZero: 'Le montant doit être supérieur à 0',
	amountMustBeLowerThan3000: 'Le montant doit être inférieur à 3000',
	inSupportOf: 'En soutien de',
	metafieldsNoTicket: 'Ligne 0. Don sans entrée',
	metafieldsTickets:
		"De combien d'invitations avez-vous besoin pour le concert ? Gardez à l'esprit que pour chaque tranche de 10 € reversés, vous recevez une invitation.",
};
